import "./Home.module.css";
import NavigationBar from "@/reusable_sections/Header";
import PackagingSolutionCoreDisplay from "./sections/PackagingSolutionCoreDisplay";
import CoreFeatures from "./sections/CoreFeatures";
import ThreeStepsToInspireCreativity from "./sections/ThreeStepsToInspireCreativity";
import EfficiencyRevolutionTraditionalVsAi from "./sections/EfficiencyRevolutionTraditionalVsAi";
import AnytimeAnywhereSeamlessSync from "./sections/AnytimeAnywhereSeamlessSync";
import FullScenarioCoverage from "./sections/FullScenarioCoverage";
import BookWithADietitian from "./sections/BookWithADietitian";
import FooterInformation from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <NavigationBar />
      <PackagingSolutionCoreDisplay />
      <CoreFeatures />
      <ThreeStepsToInspireCreativity />
      <EfficiencyRevolutionTraditionalVsAi />
      <AnytimeAnywhereSeamlessSync />
      <FullScenarioCoverage />
      <BookWithADietitian />
      <FooterInformation />
    </div>;
}